export default {
    state: {
        wallet: {
            address: '',
            type: ''
        },
        modals: {
            subscribe: false
        }
    },
    mutations: {
        setWallet(state, payload) {
            localStorage.setItem('wallet', JSON.stringify(payload));
            console.log('setAddress - ', payload);
            state.wallet = payload;
        },
        clearWallet(state) {
            localStorage.removeItem('wallet');
            state.wallet = {
                address: '',
                type: ''
            };
        },
        closeModal(state, payload) {
            state.modals[payload] = false;
        },
        openModal(state, payload) {
            state.modals[payload] = true;
        }
    }
};
